import script from "./PlayersView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayersView.vue?vue&type=script&setup=true&lang=js"

import "./PlayersView.vue?vue&type=style&index=0&id=539cbf62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-539cbf62"]])

export default __exports__